<template>
    <div >
        <b-form @submit="create(e)">
<!--            doctortype_id-->
            <b-form-group id="doctortype_id_group" label="Doctor Type Id" label-for="doctortype_id" description="The doctortype id">
                <b-form-select id="doctortype_id" v-model="form.doctortype_id" type="number" :options="id" required></b-form-select>
            </b-form-group>

<!--            name-->
            <b-form-group id="name_group" label="Name:" label-for="name" description="The fullname of doctor.">
                <b-form-input id="name" v-model="form.name" type="text" required placeholder="Enter name"></b-form-input>
            </b-form-group>

<!--            bmdc_number-->
            <b-form-group id="bmdc_number_group" label="BMDC Number:" label-for="bmdc_number" description="The registered bmdc_number of doctor. Unique for doctors.">
                <b-form-input id="bmdc_number" v-model="form.bmdc_number" type="text" required placeholder="BMDC Number"></b-form-input>
            </b-form-group>

<!--            rate-->
            <b-form-group id="rate_group" label="Rate:" label-for="rate" description="The usual rate of doctor per call/appointment.">
                <b-form-input id="rate" v-model="form.rate" type="number" required placeholder="Rate"></b-form-input>
            </b-form-group>

<!--            offer_rate-->
            <b-form-group id="offer_rate_group" label="Offer rate:" label-for="offer_rate" description="The discounted rate of doctor per call/appointment. If not presen it will be set to usual rate.">
                <b-form-input id="Offer_rate" v-model="form.offer_rate" type="number" placeholder="Offer Rate"></b-form-input>
            </b-form-group>

<!--            report_followup_rate-->
            <b-form-group id="report_followup_rate_group" label="Report Follow up Rate:" label-for="report_followup_rate" description="The rate of doctor appointment within a specific checkup period per patient. If not present it will be set to offer rate.">
               <b-form-input id="report_followup_rate" v-model="form.report_followup_rate"  placeholder="Report Follow up Rate"></b-form-input>
            </b-form-group>

<!--            gender-->
            <b-form-group id="gender_group" label="Gender" label-for="gender" description="The gender of doctor.">
                <b-form-select id="gender" v-model="form.gender" type="number" :options="gender" required></b-form-select>
            </b-form-group>

<!--            mobile-->
            <b-form-group id="mobile_group" label="Mobile" label-for="mobile" description="The mobile of doctor. Must be unique.">
                <b-form-input id="mobile" v-model="form.mobile" required type="text" placeholder="Enter mobile number"></b-form-input>
            </b-form-group>

<!--            email-->
            <b-form-group id="email-group" label="Email address:" label-for="email" description="The mail address of doctor.">
                <b-form-input id="email" v-model="form.email" type="email" required placeholder="Enter email"></b-form-input>
            </b-form-group>

<!--            workplace-->
            <b-form-group id="workplace_group" label="Work Place :" label-for="workplace" description="The workplace of doctor.">
                <b-form-input id="workplace" v-model="form.workplace" type="text" required placeholder="Enter doctor's work place"></b-form-input>
            </b-form-group>

<!--            designation-->
            <b-form-group id="designation_group" label="Designation :" label-for="designation" description="The designation of doctor.">
                <b-form-input id="designation" v-model="form.designation" type="text" required placeholder="Enter Designation of Doctor"></b-form-input>
            </b-form-group>

<!--            medical_college-->
            <b-form-group id="medical_college_group" label="Medical College :" label-for="medical_college" description="The graduation college of doctor.">
                <b-form-input id="medical_college" v-model="form.medical_college" type="text" required placeholder="Enter Medical College"></b-form-input>
            </b-form-group>

<!--            post_grad-->
            <b-form-group id="post_grad_group" label="Post Grad :" label-for="post_grad" description="Post Grad degree of doctor">
                <b-form-input id="post_grad" v-model="form.postgrad" required type="text" placeholder="Post grad"></b-form-input>
            </b-form-group>

<!--            others_training-->
            <b-form-group id="others_training_group" label="Others Training :" label-for="others_training" description="Other degrees of doctor [can be blank].">
                <b-form-input id="others_training" v-model="form.other_trainings" required type="text" placeholder="Other Trainings"></b-form-input>
            </b-form-group>


           <b-row>
               <div style="padding-right: 10px; padding-left: 15px; ">
                   <b-button type="submit" variant="danger">Create</b-button>
               </div>
           </b-row>
        </b-form>
        <b-card class="mt-3" header="Form Data Result">
            <pre class="m-0">{{ form }}</pre>
        </b-card>
    </div>
</template>

<script>
    import { Form } from 'vform';
    import DoctorService from "@/services/admin/doctor.service";
    export default {
        data() {
            return {
                form: new Form(
                    {
                      doctortype_id: null,
                      payment_style: 0,
                      name: '',
                      bmdc_number: '',
                      rate: null,
                      offer_rate: null,
                      report_followup_rate: null,
                      gender: null,
                      mobile: '',
                      email: '',
                      workplace: '',
                      designation: '',
                      medical_college: '',
                      postgrad: '',
                      other_trainings: '',
                    }
                ),
                id: [1,2,3,4,5],
                gender: [{text: 'Male', value: 0},{text: 'Female', value: 1}],
                value: ''
            }
        },
        methods: {
          create(evt){
            evt.preventDefault();
            DoctorService.createDoctor(this.form)
                .then((resposne) => {
                  if (resposne.status === 201) {
                    alert("Doctor created");
                  }
                  else{
                    alert("could not create doctor")
                  }
                })
          },
        }
    }
</script>